import moment from "moment";

// aaaa-mm-dd hh:mm:ss
export default function FormatDate(dateString: string) {
  const attDate = new Date(dateString || "");
  const dateTime = dateString?.split(" ");
  const dataCriacaoFormatted = `${moment(attDate)?.format("DD/MM/YYYY")} às ${
    dateTime ? dateTime[1] : "--"
  }`;
  return dataCriacaoFormatted;
}
